module.exports = __webpack_public_path__ + "img/diplomat.59c50366.svg";